// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STAR = "Ulo\u017e";
export const UNSTAR = "Odstr\u00e1\u0148 z ulo\u017een\u00fdch";
